<template>
  <section id="forgotPasswordPage" class="is-medium">
    <div class="columns is-gapless is-centered">
      <div class="column hero is-fullheight is-fullwidth">
        <div class="hero-body">
          <article class="is-rounded">
            <form novalidate @submit.prevent="resetPassword">
              <div class="card-content">
                <h1 class="title has-text-centered">
                  <a href="/"><img src="/static/img/hp-social-int-logo.svg" alt="logo" width="220"></a>
                </h1>
                <flash-message size="is-size-6"></flash-message>
                <br/>
                <h2 class="has-text-weight-bold has-text-centered is-size-4">Reset your password</h2>
                <p class="control">
                  <vue-password v-model="form.password" :disabled="sending" classes="input is-size-7"
                                :disableStrength="disableStrength" placeholder="Enter password">
                  </vue-password>
                </p>
                <p class="control">
                  <vue-password v-model="form.password_confirmation" :disabled="sending" classes="input is-size-7"
                                :disableStrength="disableStrength" placeholder="Re-enter password">
                  </vue-password>
                  <span class="help is-danger" v-if="passwordsDontMatch">Passwords don't match</span>
                  <span class="help is-success" v-if="passwordsMatch">Passwords match</span>
                </p>
                <p class="control">
                  <button :disabled="!passwordsMatch" type="submit"
                          class="margin-top-30 button is-button-blue is-fullwidth is-size-7 is-uppercase has-text-weight-bold"
                          :class="[{ 'is-loading': sending}]">Reset Password</button>
                </p>
              </div>
            </form>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '@/api/ApiResource'
  import VuePassword from 'vue-password'
  import FlashMessage from '@/components/FlashMessage'

  export default {
    name: 'UpdatePassword',
    props: {
      token: {
        type: String
      }
    },
    components: {
      VuePassword,
      FlashMessage
    },
    metaInfo: {
      title: 'Hellopeter | Update Password'
    },
    data () {
      return {
        has_errors: false,
        disableStrength: true,
        sending: false,
        form: new ApiResource({
          password: '',
          password_confirmation: '',
          consumer: true
        })
      }
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Update Password'
      })
      window.prerenderReady = true
    },
    created () {
      this.verifyToken()
    },
    computed: {
      passwordsDontMatch () {
        return (this.form.password.length > 0 && this.form.password_confirmation.length > 0) && this.form.password !== this.form.password_confirmation
      },
      passwordsMatch () {
        return this.form.password.length > 0 && this.form.password === this.form.password_confirmation
      }
    },
    methods: {
      verifyToken () {
        const resetToken = new ApiResource({})
        resetToken.send(`/update-password/${this.token}`, {}, 'get')
          .catch(() => {
            window.location.href = '/404'
          })
      },
      resetPassword () {
        this.sending = true
        this.form.send(`/update-password/${this.token}`)
          .then(() => {
            this.sending = false
            this.$router.push({
              path: '/login',
              query: {notification: 'Your password has been changed successfully. Sign in to continue'}
            })
            flash('Your password has been changed successfully. Sign in to continue', 'is-success')
          })
          .catch(() => {
            this.sending = false
            flash(this.form.errors.getDefaultErrorMessage(), 'is-danger')
          })
      }
    }
  }
</script>
<style lang="scss">
  #forgotPasswordPage .control {
    margin-bottom: 10px;
  }

  #forgotPasswordPage article {
    max-width: 403px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    box-shadow: none;
  }

  #forgotPasswordPage #loginButton {
    margin-top: 30px;
  }

  .link-with-underline {
    color: #2FABE1;
    text-decoration: underline;
  }

  .column-with-bg{
    background-color: #2FABE1;
    background-image: url("/static/img/login-icons.svg");
    background-size: cover;
  }

  .column-with-bg p {
    margin-left: auto;
    margin-right: auto;
    color: #ffffff;
    opacity: 0.5;
    padding-left: 6rem;
    padding-right: 6rem;
    line-height: 6rem;
  }

  #forgotPasswordPage input {
    border-radius: 0!important;
    border: 1px solid #dbdbdb!important;
    box-shadow: none!important;
    height: 2.5rem;
    font-size: 0.9rem;
    color: #58595B;
    padding-left: 1rem!important;
  }

  #forgotPasswordPage .control {
    margin-top: 30px;
  }

  #forgotPasswordPage button {
    border: 0;
    border-radius: 0;
    height: 2.5rem;
    color: #ffffff;
    background-color: #2FABE1;
    font-size: 0.9rem;
  }

  #forgotPasswordPage a.VuePassword__Toggle {
    color: gray!important;
  }

  .fb-button {
    background-color: #3B5998!important;
    font-size: 0.85rem!important;
  }

  .tw-button {
    background-color: #1DA1F2!important;
    font-size: 0.85rem!important;
  }

  .fb-button > i, .tw-button > i {
    font-size: 1.5rem!important;
    margin-right: 0.5rem;
  }

  #launch-text {
    position: absolute;
    bottom: 50px;
    right: 50px;
    color: #ffffff;
  }

  .control.has-icons-right {
    margin-top: 1rem!important;
  }

  .divider {
    display: flex;

    &:before,
    &:after {
      content: "";
      flex: 1;
    }
  }

  // Base line
  .line {
    align-items: center;
    margin: 1em -1em;

    &:before,
    &:after {
      height: 1px;
      margin: 0 1em;
    }
  }


  .one-line {
    &:before,
    &:after {
      background: #DBDBDB;
    }
  }

  .control.divider.line.one-line.has-text-weight-bold {
    font-size: 0.9rem;
    color: #58595B;
  }

  .title {
    margin-bottom: 0!important;
  }

  @media screen and (max-width: 768px) {
    #forgotPasswordPage .column:not(:first-child) p {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  h2 {
    margin-bottom: 1rem;
  }

  .help {
    margin-top: .25rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UpdatePassword.vue